import ResizeObserverPolyfill from 'resize-observer-polyfill';

const getResizeObserver = () => {
  if ('ResizeObserver' in window) {
    return window.ResizeObserver;
  }

  return ResizeObserverPolyfill;
};

export const ResizeObserver = getResizeObserver();
